import styled from "styled-components";

export const InactivityTimeoutSettingsBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 150px;
    font-size: 14px;
    ${props => props.theme.font.presets.bold};
`